// Réglages de l'appareil choisis dans « Paramètres » : langue de l'interface et mode nuit.
// Ils sont gardés sur l'appareil (le stockage peut être indisponible : valeurs par défaut).
import { installerTraduction } from "./traduction";

export const CLE_LANGUE = "ql_langue";
export const CLE_THEME = "ql_theme";
export const LANGUES = [["fr", "Français"], ["en", "English"]];
export const THEMES = [["clair", "Mode clair"], ["sombre", "Mode nuit"], ["auto", "Automatique (comme le téléphone)"]];

function lire(cle, defaut, permis) {
  try {
    const valeur = window.localStorage.getItem(cle);
    return permis.includes(valeur) ? valeur : defaut;
  } catch { return defaut; }
}
function ecrire(cle, valeur) {
  try { window.localStorage.setItem(cle, valeur); } catch { /* stockage indisponible */ }
}

export const langue = () => lire(CLE_LANGUE, "fr", ["fr", "en"]);
export const theme = () => lire(CLE_THEME, "clair", ["clair", "sombre", "auto"]);

const requeteSombre = () => window.matchMedia?.("(prefers-color-scheme: dark)");

export function appliquerTheme(choix = theme()) {
  const sombre = choix === "sombre" || (choix === "auto" && !!requeteSombre()?.matches);
  document.documentElement.setAttribute("data-theme", sombre ? "dark" : "light");
  return sombre;
}

export function definirTheme(choix) {
  ecrire(CLE_THEME, choix);
  appliquerTheme(choix);
}

// Le retour au français recharge la page : les textes d'origine sont réaffichés tels quels.
export function definirLangue(choix) {
  if (choix === langue()) return;
  ecrire(CLE_LANGUE, choix);
  if (choix === "en") installerTraduction();
  else window.location.reload();
}

export function installerPreferences() {
  appliquerTheme();
  const requete = requeteSombre();
  const suivre = () => { if (theme() === "auto") appliquerTheme("auto"); };
  if (requete?.addEventListener) requete.addEventListener("change", suivre);
  else requete?.addListener?.(suivre);
  if (langue() === "en") installerTraduction();
}
